import React from 'react';

const icon = ({ className = '', ...props }) => (
  <span className={`svg-icon ${className}`} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" stroke="currentColor" strokeLinejoin="round">
        <path d="M32.474 11.518v15.531l-12.472 7.304L7.529 27.46V11.527l12.473 6.415M20.002 34.353V17.942" />
        <path strokeLinecap="round" d="M32.474 11.518L20.002 5.647 7.529 11.494M32.308 11.612l-12.109 6.355M21.985 30.406l3.987-2.211M21.985 28.093l1.998-1.107" />
        <path strokeLinecap="round" d="M25.417 8.417l-11.834 6.166v3.042" />
      </g>
    </svg>
  </span>
);

export default icon;
